// @ts-nocheck
// oxlint-disable no-unused-vars
import type {
	ApiResponseOfIReadOnlyListOfProjectDto,
	ApiResponseOfIReadOnlyListOfUserDto,
	ApiResponseOfUserDto,
	UpdateUserEmailRequest,
	UpdateUserPasswordRequest,
	UpdateUserRequest,
	UpdateUserRoleRequest,
} from "../types";
import { apiFetch, type ApiResponse } from "@/api/fetch";

/** Auto-generated file. Do not edit. */

/**
 * DELETE `/users/me`
 */
export const deleteApiUsersMe = () =>
	apiFetch<ApiResponse<null>>({
		uri: "users/me",
		method: "DELETE",
	});

/**
 * GET `/users`
 */
export const getApiUsers = () =>
	apiFetch<ApiResponseOfIReadOnlyListOfUserDto>({
		uri: "users",
		method: "GET",
	});

/**
 * GET `/users/me`
 */
export const getApiUsersMe = () =>
	apiFetch<ApiResponseOfUserDto>({
		uri: "users/me",
		method: "GET",
	});

/**
 * GET `/users/${id}/projects`
 */
export const getApiUsersProjectsById = ({
	id,
}: {
	/** @format uuid */
	id: string;
}) =>
	apiFetch<ApiResponseOfIReadOnlyListOfProjectDto>({
		uri: `users/${id}/projects`,
		method: "GET",
	});

/**
 * PUT `/users/${id}/email`
 */
export const putApiUsersEmailById = (
	{
		id,
	}: {
		/** @format uuid */
		id: string;
	},
	data: UpdateUserEmailRequest,
) =>
	apiFetch<ApiResponse<null>>({
		uri: `users/${id}/email`,
		method: "PUT",
		body: data,
	});

/**
 * PUT `/users/me`
 */
export const putApiUsersMe = (data: UpdateUserRequest) =>
	apiFetch<ApiResponse<null>>({
		uri: "users/me",
		method: "PUT",
		body: data,
	});

/**
 * PUT `/users/${id}/password`
 */
export const putApiUsersPasswordById = (
	{
		id,
	}: {
		/** @format uuid */
		id: string;
	},
	data: UpdateUserPasswordRequest,
) =>
	apiFetch<ApiResponse<null>>({
		uri: `users/${id}/password`,
		method: "PUT",
		body: data,
	});

/**
 * PUT `/users/${id}/role`
 */
export const putApiUsersRoleById = (
	{
		id,
	}: {
		/** @format uuid */
		id: string;
	},
	data: UpdateUserRoleRequest,
) =>
	apiFetch<ApiResponse<null>>({
		uri: `users/${id}/role`,
		method: "PUT",
		body: data,
	});
